import { RISK_CATEGORY_SELECT_OPTIONS } from '../../constants/riskCategories';

export const RCM_RISK_CATEGORY_FILTER_OPTIONS = [
  { label: 'Risk Categories (All)', value: 'all' },
  ...RISK_CATEGORY_SELECT_OPTIONS,
];

export const RCM_FILTER_SELECT_STYLES = {
  placeholder: (base, state) => ({
    ...base,
    fontWeight: 600,
    color: state.isFocused ? '#9ca3af' : 'black',
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: 600,
    color: '#000000',
  }),
  control: (base) => ({
    ...base,
    minHeight: '2.25rem',
    height: '2.25rem',
  }),
  valueContainer: (base) => ({
    ...base,
    height: '2.25rem',
    paddingTop: 0,
    paddingBottom: 0,
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '2.25rem',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? '#dbeafe' : state.isFocused ? '#eff6ff' : base.backgroundColor,
    color: '#1f2937',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 50,
  }),
};
